module.exports = __webpack_public_path__ + "static/img/banner.5804997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/publicService/banner.png
// module id = mcHc
// module chunks = 44